import { ListMetricsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { MetricType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/metrics_pb';
import { ListSimulationMetricsResponse } from '@wavingroup/aqora-v2-crate/wavin/simulations/v1/simulations_service_pb';

export class WaterLevelsModel {
  private waterLevelByReservoirName: Map<string, number | undefined>;

  private capacityUsedPercentage: Map<string, number | undefined>;

  private capacityUsedVolume: Map<string, number | undefined>;

  constructor(
    private metricResponse: ListMetricsResponse | ListSimulationMetricsResponse,
  ) {
    this.waterLevelByReservoirName = new Map<string, number | undefined>();

    this.capacityUsedPercentage = new Map<string, number | undefined>();

    this.capacityUsedVolume = new Map<string, number | undefined>();

    this.metricResponse.metrics.forEach((metric) => {
      const value = metric.dataPoints[0]?.value.value;

      const valueToSet = value !== undefined ? Number(value) : undefined;

      if (metric.type === MetricType.WATER_HEIGHT_MM) {
        this.waterLevelByReservoirName.set(metric.resourceName, valueToSet);
      }

      if (metric.type === MetricType.CALCULATED_WATER_PERCENTAGE) {
        this.capacityUsedPercentage.set(metric.resourceName, valueToSet);
      }

      if (metric.type === MetricType.CALCULATED_WATER_VOLUME_M3) {
        this.capacityUsedVolume.set(metric.resourceName, valueToSet);
      }
    });
  }

  getWaterLevelByReservoirName(reservoirName: string): number | undefined {
    return this.waterLevelByReservoirName.get(reservoirName);
  }

  getCapacityUsedPercentage(reservoirName: string): number | undefined {
    return this.capacityUsedPercentage.get(reservoirName);
  }

  getCapacityUsedVolume(reservoirName: string): number | undefined {
    return this.capacityUsedVolume.get(reservoirName);
  }
}
